export const serviceUrl = 'https://us-central1-contactservice-389003.cloudfunctions.net/';